let apiAjax = false // Ajaxリクエスト
let apiAjaxResponse = '' // 最後のレスポンスを格納する

/*
APIのURLにデータを送信する
<button type="btn" class="js-api" data-param="hoge=aaa&fuga=bbb&foo=ccc">
</button>
*/

window.addEventListener('click', (e) => {
  if (e.target.classList.contains('js-api')) {
    if (e.target.tagName !== 'LABEL') {
      e.preventDefault()
    }
    const item = e.target
    let api = item.dataset.api // API送信先
    const param = item.dataset.param // パラメータ
    const jump = item.dataset.jump // 終了後の移動先
    if (!api) {
      /* global apiUrl */
      api = apiUrl // デフォルトのAPI送信先を取得
    }

    window.apiAjax(param, api, jump)
  }
})

/*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
/**
 * Ajax処理を実行する
 * @param param {string} hoge=aaa&fuga=bbb&foo=ccc
 */
window.apiAjax = function (param, api, jump) {
  let url = api
  const method = 'get'
  if (apiAjax) {
    // 既に通信中なら切断
    apiAjax.abort()
  }

  apiAjax = new XMLHttpRequest() // Ajaxリクエスト
  if (method === 'post') {
    apiAjax.open(method, url, true) // GET/POST, URL, 非同期処理
  } else {
    if (param) {
      url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
    }

    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
    apiAjax.open(method, url, true) // GET/POST, URL, 非同期処理
  }
  apiAjax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
  // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
  // ajax.setRequestHeader('Pragma', 'no-cache')
  // ajax.setRequestHeader('Cache-Control', 'no-cache')
  // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
  if (method === 'post') {
    apiAjax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
  }
  apiAjax.responseType = 'document' // 取得タイプ document text json
  apiAjax.timeout = 10000 // タイムアウト判定時間
  if (method === 'post') {
    apiAjax.send(param) // POSTリクエスト実行
  } else {
    apiAjax.send() // GETリクエスト実行
  }
  apiAjax.onload = function () {
    // アクセス成功
    if (apiAjax.status < 200 || apiAjax.status >= 400) {
      console.log('Error: Code ' + apiAjax.status) // エラー
      return
    }
    if (jump) {
      window.location.href = jump
    }
  }
  apiAjax.ontimeout = function (e) {
    // タイムアウト
  }
  apiAjax.onerror = function () {
    // 処理失敗
  }
  apiAjax.onloadend = function () {
    // 受信成否に関わらず実行
    apiAjax = false
  }
}
